import { useState, useEffect } from "react";
import AdminHeader from "../../../Component/AdminHeader/AdminHeader";
import "./Category.css";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { FiUpload } from "react-icons/fi";

// Context & JWT decoding
import { useAdminAuth } from "../../../ContextAPI/AdminContex";
import { decodeJWT } from "../../../Utils/DecodeJWT";

export default function CreateCategories() {
  const navigate = useNavigate();
  const location = useLocation();

  // Extract data from navigate state
  const stall_id = location.state?.stall_id;
  const stall = location.state?.stall;
  const owner_id = location.state?.owner_id;
  const owner = location.state?.owner;

  const API = "https://fliplyn-b-c.fly.dev";

  const { admin } = useAdminAuth();
  const decoded = admin?.token ? decodeJWT(admin.token) : null;
  const admin_id = decoded?.id || decoded?.admin_id || decoded?.sub || null;

  const [categoryName, setCategoryName] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  // Console everything on page load
  useEffect(() => {
    console.log("=============== CATEGORY SCREEN LOADED ===============");
    console.log("stall_id       =>", stall_id);
    console.log("stall          =>", stall);
    console.log("owner          =>", owner);
    console.log("owner_id       =>", owner_id);
    console.log(
      owner_id
        ? "🟢 owner_id exists and received successfully"
        : "❌ owner_id is MISSING – navigate() did not pass it"
    );
    console.log("admin (context)=>", admin);
    console.log("decoded JWT    =>", decoded);
    console.log("admin_id       =>", admin_id);
    console.log("=======================================================");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // run only once on mount

  const handleFile = (e) => {
    const img = e.target.files[0];
    setFile(img);
    console.log("📸 Image Selected:", img);
  };

const handleCreate = async () => {
  console.log("🔍 SUBMIT CLICKED — Checking values...");
  console.log("CategoryName:", categoryName);
  console.log("Uploaded Image:", file);
  console.log("stall_id:", stall_id);
  console.log("owner_id:", owner_id);
  console.log("admin_id:", admin_id);

  // Validations
  if (!categoryName.trim()) return alert("Category name is required!");
  if (!file) return alert("Image is required!");
  if (!stall_id || !owner_id || !admin_id)
    return alert("❌ Missing stall_id / owner_id / admin_id — check console");

  setLoading(true);

  try {
    // Prepare FormData
    const formData = new FormData();
    formData.append("name", categoryName);
    formData.append("stall_id", stall_id);
    formData.append("owner_id", owner_id);
    formData.append("admin_id", admin_id);

    if (file) {
      formData.append("file", file); // must match backend parameter name
    }

    console.log("📦 FormData Ready — Sending to backend...");

    // POST request — do NOT manually set Content-Type
    await axios.post(`${API}/categories/`, formData);

    console.log("🎉 CATEGORY CREATED SUCCESSFULLY");

    // Navigate back to list
    navigate("/list-category", {
      state: { stall_id, stall, owner, owner_id },
    });
  } catch (err) {
    console.error("❌ CATEGORY CREATE ERROR:", err.response?.data || err);
    alert("Failed to create category. Check console.");
  } finally {
    setLoading(false);
  }
};

  return (
    <div>
      <AdminHeader />
      <div className="category-page">
        <h1 className="page-title">Manage Categories</h1>

        <div className="add-category-card">
          <h2 className="section-title">Add New Category</h2>

          <div className="form-row">
            {/* Category Name */}
            <div className="form-group">
              <label>
                Category Name <span className="required">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter Category name"
                value={categoryName}
                onChange={(e) => setCategoryName(e.target.value)}
              />
            </div>

            {/* Upload Image */}
            <div className="form-group">
              <label>
                Upload Image <span className="required">*</span>
              </label>

              <div className="upload-box">
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleFile}
                  className="file-input"
                />

                {file ? (
                  <div className="preview-box">
                    <img
                      src={URL.createObjectURL(file)}
                      alt="preview"
                      className="preview-img"
                    />
                    <p className="preview-name">{file.name}</p>
                  </div>
                ) : (
                  <div className="upload-content">
                    <FiUpload size={28} className="upload-react-icon" />
                    <p>Click to Upload</p>
                    <span>Supported: JPG, PNG</span>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="btn-row">
            <button
              className="cancel-button"
              onClick={() =>
                navigate("/list-category", {
                  state: { stall_id, stall, owner, owner_id },
                })
              }
            >
              Cancel
            </button>

            <button className="create-btn" onClick={handleCreate} disabled={loading}>
              {loading ? "Creating..." : "Create Category"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
